import React from "react";

export default function Support() {
  return (
    <div>
      <p>Support</p>
    </div>
  );
}
